// You can write more code here

import MentorDialoguePanel from '@/game/prefabs/Assessment/MentorDialoguePanel';

/* START OF COMPILED CODE */

export default class AssessmentIntro extends Phaser.Scene {
  constructor() {
    super('AssessmentIntro');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // assessmentTutorial
    const assessmentTutorial = this.add.container(0, 0);

    // mentorDialoguePanel
    const mentorDialoguePanel = new MentorDialoguePanel(this, 0, 0);
    assessmentTutorial.add(mentorDialoguePanel);

    // curtain
    const curtain = this.add.image(0, 0, '1x1sprite');
    curtain.scaleX = 1600;
    curtain.scaleY = 1024;
    curtain.setOrigin(0, 0);
    curtain.tintTopLeft = 0;
    curtain.tintTopRight = 0;
    curtain.tintBottomLeft = 0;
    curtain.tintBottomRight = 0;
    assessmentTutorial.add(curtain);

    this.mentorDialoguePanel = mentorDialoguePanel;
    this.curtain = curtain;

    this.events.emit('scene-awake');
  }

  public mentorDialoguePanel!: MentorDialoguePanel;
  private curtain!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
  }

  reveal() {
    this.tweens.add({
      targets: this.curtain,
      duration: 1000,
      ease: 'linear',
      alpha: 0,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
